var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.343,
    height: 70,
    viewBox: "0 0 76.343 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 76.343,
    height: 70,
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(-1474.157 -6479.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(1474.157 6479.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43670",
    "data-name": "Path 43670",
    d: "M58.525,53.453c0,.494.01.911,0,1.328a3.8,3.8,0,0,1-3.76,3.755c-1.688.03-3.378.006-5.141.006,0,.867-.029,1.657.021,2.442.012.19.251.425.445.534a3.786,3.786,0,0,1,1.74,4.894,3.746,3.746,0,0,1-4.589,2.152,3.788,3.788,0,0,1-2.672-3.325A3.645,3.645,0,0,1,46.5,61.6a.872.872,0,0,0,.592-.955c-.048-.658-.012-1.322-.012-2.1H44.3c-.742,0-1.484.008-2.227,0a3.819,3.819,0,0,1-3.9-3.939c0-.343,0-.687,0-1.15H33.318c.245.314.409.527.577.737a18.845,18.845,0,0,1,4.267,11.8,3.784,3.784,0,0,1-3.912,4q-15.149.016-30.3,0A3.81,3.81,0,0,1,0,65.949,19.108,19.108,0,0,1,11.866,48.528l.847-.348C6,44.052,3.594,38.236,6.082,30.762c2-6,6.75-8.9,14.274-9.126v-.827q0-7.039,0-14.078A6.371,6.371,0,0,1,27.092,0Q48.364,0,69.636,0a6.361,6.361,0,0,1,6.7,6.681q.008,20.043,0,40.087a6.368,6.368,0,0,1-6.705,6.681q-5.089.007-10.179,0Zm-32.992-5.4c1.49.837,2.975,1.688,4.478,2.505a2.425,2.425,0,0,0,1.088.339q19.317.026,38.633.012a3.824,3.824,0,0,0,4.062-4.1q.005-20.076,0-40.152a3.825,3.825,0,0,0-4.126-4.11q-21.3,0-42.608,0A3.835,3.835,0,0,0,22.9,6.7c0,4.877.01,9.753-.015,14.63a.951.951,0,0,0,.773,1.115,14.045,14.045,0,0,1,6.482,21.789,14.593,14.593,0,0,1-4.609,3.81m4.941-12.224A11.271,11.271,0,0,0,19.311,24.19a11.444,11.444,0,0,0-.776,22.872c6.678.141,11.725-4.4,11.939-11.239M7.632,67.448c0-.843-.008-1.582,0-2.32.013-.928.514-1.5,1.286-1.488s1.243.58,1.254,1.522c.009.756,0,1.512,0,2.246H27.991c0-.779-.007-1.515,0-2.251.011-.941.488-1.509,1.258-1.517s1.27.563,1.282,1.493c.011.757,0,1.515,0,2.244a1.581,1.581,0,0,0,.255.066c1.06,0,2.12.012,3.18.008,1.233,0,1.709-.45,1.642-1.685a16.308,16.308,0,0,0-9.49-14.523,13.087,13.087,0,0,0-4.652-1.373c.107.311.18.534.26.755q1.747,4.812,3.495,9.624c.5,1.378,0,2.11-1.454,2.112q-4.651.006-9.3,0c-1.513,0-2.028-.718-1.521-2.121q1.743-4.814,3.492-9.625c.083-.231.143-.47.238-.782a16.326,16.326,0,0,0-9.347,4.746A16.19,16.19,0,0,0,2.55,65.93c-.022.936.424,1.484,1.256,1.508,1.24.036,2.482.009,3.827.009m48.35-13.941H40.714c0,.342,0,.631,0,.919.014,1.127.457,1.56,1.606,1.571.344,0,.688,0,1.032,0q5.517,0,11.035,0c1.141,0,1.582-.449,1.595-1.582,0-.287,0-.574,0-.907M22.344,59.784l-3.181-8.742-.185.039-3.148,8.7Zm27.259,5.1a1.255,1.255,0,1,0-1.238,1.283A1.244,1.244,0,0,0,49.6,64.889",
    transform: "translate(0 0)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43671",
    "data-name": "Path 43671",
    d: "M110.385,57.487a14.593,14.593,0,0,0,4.609-3.81,14.045,14.045,0,0,0-6.482-21.789.951.951,0,0,1-.773-1.115c.024-4.876.011-9.753.015-14.63a3.835,3.835,0,0,1,4.158-4.157q21.3,0,42.608,0a3.825,3.825,0,0,1,4.126,4.11q.005,20.076,0,40.152a3.824,3.824,0,0,1-4.062,4.1q-19.317.007-38.633-.012a2.423,2.423,0,0,1-1.088-.339c-1.5-.817-2.989-1.668-4.478-2.505M133.161,33.62H146.6a5.086,5.086,0,0,0,.793-.025,1.221,1.221,0,0,0,1.052-1.291,1.189,1.189,0,0,0-1.057-1.2,4.788,4.788,0,0,0-.793-.024H119.8a4.932,4.932,0,0,0-.793.024,1.244,1.244,0,0,0-.947,1.75c.284.687.86.774,1.506.773q6.8-.01,13.6,0m-.041,17.817h12.245a4.468,4.468,0,0,0,.714-.019,1.266,1.266,0,0,0,0-2.507,4.678,4.678,0,0,0-.714-.018H121.033a3.948,3.948,0,0,0-.792.031,1.267,1.267,0,0,0,0,2.481,3.948,3.948,0,0,0,.792.031q6.043,0,12.086,0m.081-26.726c3.313,0,6.626-.005,9.939,0a1.289,1.289,0,0,0,1.467-1.043c.191-.884-.448-1.5-1.55-1.5q-7.951-.006-15.9,0c-1.352,0-2.7-.016-4.055.008a1.241,1.241,0,0,0-1.308,1.5,1.293,1.293,0,0,0,1.471,1.039c3.313-.01,6.626,0,9.939,0m0,17.817c2.438,0,4.877,0,7.315,0,1.02,0,1.572-.459,1.573-1.274s-.55-1.267-1.576-1.268q-7.315-.005-14.63,0c-1.021,0-1.573.457-1.572,1.272s.552,1.268,1.575,1.27c2.438.005,4.877,0,7.315,0",
    transform: "translate(-84.851 -9.438)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43672",
    "data-name": "Path 43672",
    d: "M58.773,125.48c-.214,6.842-5.262,11.38-11.939,11.239a11.444,11.444,0,0,1,.776-22.873A11.271,11.271,0,0,1,58.773,125.48",
    transform: "translate(-28.299 -89.657)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43673",
    "data-name": "Path 43673",
    d: "M17.084,252.2c-1.344,0-2.586.027-3.827-.009-.832-.024-1.278-.573-1.256-1.508a16.576,16.576,0,0,1,14.128-16.1c-.094.312-.154.551-.238.782q-1.744,4.813-3.492,9.625c-.508,1.4.008,2.12,1.521,2.121q4.651,0,9.3,0c1.449,0,1.953-.734,1.454-2.112q-1.743-4.814-3.495-9.624c-.08-.221-.153-.444-.26-.755a13.087,13.087,0,0,1,4.652,1.373,16.308,16.308,0,0,1,9.49,14.523c.067,1.235-.409,1.682-1.642,1.685-1.06,0-2.12,0-3.18-.008a1.573,1.573,0,0,1-.255-.066c0-.728.008-1.486,0-2.244-.013-.93-.51-1.5-1.282-1.493s-1.247.576-1.258,1.517c-.009.736,0,1.473,0,2.251H19.628c0-.734.007-1.49,0-2.246-.011-.942-.486-1.511-1.254-1.522s-1.274.56-1.286,1.487c-.01.739,0,1.478,0,2.32",
    transform: "translate(-9.451 -184.751)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43674",
    "data-name": "Path 43674",
    d: "M206.921,251.876c0,.333,0,.62,0,.907-.013,1.133-.454,1.581-1.595,1.582q-5.517.007-11.035,0c-.344,0-.688,0-1.032,0-1.149-.011-1.592-.444-1.606-1.571,0-.289,0-.577,0-.919Z",
    transform: "translate(-150.938 -198.369)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43675",
    "data-name": "Path 43675",
    d: "M81.028,249.015H74.513l3.148-8.7.185-.039,3.181,8.742",
    transform: "translate(-58.684 -189.231)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43676",
    "data-name": "Path 43676",
    d: "M224.194,300.827a1.255,1.255,0,1,1-1.271-1.248,1.249,1.249,0,0,1,1.271,1.248",
    transform: "translate(-174.591 -235.938)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1,
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43677",
    "data-name": "Path 43677",
    d: "M171.023,104.382q-6.8,0-13.6,0c-.646,0-1.222-.087-1.506-.773a1.244,1.244,0,0,1,.947-1.75,4.906,4.906,0,0,1,.793-.024h26.8a4.789,4.789,0,0,1,.793.024,1.189,1.189,0,0,1,1.057,1.2,1.221,1.221,0,0,1-1.052,1.291,5.087,5.087,0,0,1-.793.025H171.023",
    transform: "translate(-122.713 -80.2)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43678",
    "data-name": "Path 43678",
    d: "M175.724,188.251q-6.043,0-12.086,0a3.948,3.948,0,0,1-.792-.031,1.267,1.267,0,0,1,0-2.481,3.934,3.934,0,0,1,.793-.031q12.165,0,24.331,0a4.651,4.651,0,0,1,.714.018,1.266,1.266,0,0,1,0,2.507,4.469,4.469,0,0,1-.714.019H175.724",
    transform: "translate(-127.455 -146.252)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43679",
    "data-name": "Path 43679",
    d: "M194.638,146.327c-2.438,0-4.877,0-7.315,0-1.023,0-1.575-.455-1.575-1.27s.551-1.271,1.572-1.272q7.315-.005,14.63,0c1.026,0,1.576.454,1.576,1.268s-.553,1.272-1.573,1.274c-2.438.005-4.877,0-7.315,0",
    transform: "translate(-146.289 -113.237)",
    fill: "#f5b85b",
    stroke: "#f5b85b",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic6);
export default __webpack_public_path__ + "static/media/topic6.7e11464cdfe94c2ad462f5d8eceb6941.svg";
export { ForwardRef as ReactComponent };